// ========================================
//   mindfulness-breakfast_common.js
// ========================================

//ヘッダーの背景切り替え（TOPのみ）
document.addEventListener('DOMContentLoaded', function () {
  const header = document.querySelector('.section-header');

  // トップページ判定
  const isTopPage =
    window.location.pathname === '/' ||
    window.location.pathname === '/ja' ||  // 多言語対応（必要に応じて変更）
    document.body.classList.contains('template-index'); // Craftテーマの body クラス対応

  if (!header || !isTopPage) return;

  // 初回：transparent-header クラスを付与
  header.classList.add('transparent-header');

  // スクロールでクラスを切り替え
  function toggleHeaderBackground() {
    if (window.scrollY > 10) {
      header.classList.remove('transparent-header');
    } else {
      header.classList.add('transparent-header');
    }
  }

  window.addEventListener('scroll', toggleHeaderBackground);
  toggleHeaderBackground(); // 初期チェック
});



// アンカーリンク　位置調整
document.addEventListener("DOMContentLoaded", function () {
  // 現在のURLにハッシュ（#id）があるかチェック
  const hash = window.location.hash;
  if (hash) {
    const target = document.querySelector(hash);
    if (target) {
      // ヘッダーの高さを取得（固定ヘッダーのclass名に合わせて調整）
      const header = document.querySelector('.header-wrapper'); // Craftテーマの場合の例
      const headerHeight = header ? header.offsetHeight : 0;

      // 少し待ってからスクロール（ページ読み込み後すぐはDOMの位置が安定しないため）
      setTimeout(function () {
        const elementTop = target.getBoundingClientRect().top + window.pageYOffset;
        window.scrollTo({
          top: elementTop - headerHeight - 10, // 調整分の余白
          behavior: 'smooth'
        });
      }, 300);
    }
  }
});



// // メインスライダーの高さ（swiper）を100vhに固定
// function adjustSwiperHeight() {
//   const swipers = document.querySelectorAll('.mainSwiperPc, .mainSwiperSp');
//   swipers.forEach(swiper => {
//     swiper.style.height = '100vh';
//   });
// }
// // 初期 & リサイズ時に実行
// document.addEventListener('DOMContentLoaded', adjustSwiperHeight);
// window.addEventListener('resize', adjustSwiperHeight);



// メインスライダーの高さ（swiper）を100vhに固定
function adjustSwiperHeightOnce() {
  const swipers = document.querySelectorAll('.mainSwiperPc, .mainSwiperSp');
  const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

  // 最初の高さを保存（スクロールによる変化を防ぐ）
  const initialHeight = isMobile ? window.innerHeight : null;

  function setHeight() {
    const height = isMobile ? initialHeight + 'px' : '100vh';
    swipers.forEach(swiper => {
      swiper.style.height = height;
    });
  }

  setHeight();

  // PCだけリサイズ対応（スマホは高さ固定）
  if (!isMobile) {
    window.addEventListener('resize', setHeight);
  }
}
document.addEventListener('DOMContentLoaded', adjustSwiperHeightOnce);




// top_about_box（メインイメージ分、調整）
function adjustTopAboutBoxMargin() {
  const swiperPc = document.querySelector('.mainSwiperPc');
  const swiperSp = document.querySelector('.mainSwiperSp');
  const aboutBox = document.querySelector('.top_about_box');
  const announcementBar = document.querySelector('.announcement-bar-section');
  const header = document.querySelector('.section-header');

  if (aboutBox) {
    // 高さの取得（表示されているswiperの高さを使う）
    let swiperHeight = 0;

    if (swiperPc && window.getComputedStyle(swiperPc).display !== 'none') {
      swiperHeight = swiperPc.offsetHeight;
    } else if (swiperSp && window.getComputedStyle(swiperSp).display !== 'none') {
      swiperHeight = swiperSp.offsetHeight;
    }

    const announcementHeight = announcementBar ? announcementBar.offsetHeight : 0;
    const headerHeight = header ? header.offsetHeight : 0;

    const marginTop = swiperHeight - (announcementHeight + headerHeight);
    aboutBox.style.marginTop = `${marginTop}px`;
  }
}

// 初期実行
document.addEventListener('DOMContentLoaded', adjustTopAboutBoxMargin);
// リサイズ対応
window.addEventListener('resize', adjustTopAboutBoxMargin);





// infoポップアップ
(() => {
  if (window.__gwTipBound) return; // 二重バインド防止
  window.__gwTipBound = true;

  const isTouch = matchMedia('(hover: none), (pointer: coarse)').matches;

  // ボタンクリックで開閉（主にスマホ）
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.gw-tip__btn');
    const tip = e.target.closest('.gw-tip');

    // どこか別の場所をクリックしたら全て閉じる
    document.querySelectorAll('.gw-tip.is-open').forEach(el => {
      if (!tip || el !== tip) {
        el.classList.remove('is-open');
        const b = el.querySelector('.gw-tip__btn');
        if (b) b.setAttribute('aria-expanded', 'false');
      }
    });

    if (btn) {
      const parent = btn.closest('.gw-tip');
      const willOpen = !parent.classList.contains('is-open');
      parent.classList.toggle('is-open', willOpen);
      btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      e.stopPropagation();
    }
  });

  // Escで閉じる
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      document.querySelectorAll('.gw-tip.is-open').forEach(el => {
        el.classList.remove('is-open');
        const b = el.querySelector('.gw-tip__btn');
        if (b) b.setAttribute('aria-expanded', 'false');
      });
    }
  });

  // ホバー可の環境では、クリックで固定開きしない（ホバーに任せる）
  if (!isTouch) {
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('.gw-tip__btn');
      if (btn) e.preventDefault(); // デスクトップではクリックでトグルしない
    }, true);
  }
})();